module.exports = __webpack_public_path__ + "19cb39b14c4246bff1c74e651ba125ca.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/formFactors/ptz.png
// module id = 1645
// module chunks = 5